import type { TArticle, TStep } from 'shared/types/carousel';
import type { EDealType, EOfferType } from 'shared/types/features';

type TFilters = {
  dealType?: EDealType | null;
  offerType?: EOfferType | null;
};

const matchesArticleFilters = (article: TArticle, filters: TFilters): boolean => {
  if (filters.dealType && !article.dealTypes?.includes(filters.dealType)) {
    return false;
  }

  if (filters.offerType && !article.offerTypes?.includes(filters.offerType)) {
    return false;
  }

  return true;
};

/**
 * Фильтрует шаги по dealType / offerType.
 * Статья без соответствующего массива фильтров не проходит.
 * Шаг без статей после фильтрации отбрасывается.
 */
export const filterStepsByFilters = (steps: TStep[], filters: TFilters = {}): TStep[] => {
  const { dealType, offerType } = filters;

  if (!dealType && !offerType) {
    return steps;
  }

  return steps
    .map(step => ({
      ...step,
      slides: step.slides.filter(article => matchesArticleFilters(article, filters)),
    }))
    .filter(step => step.slides.length > 0);
};
